const siteOrigin = window.location.origin;
const removeUnwantedSpaces = (htmlElement) => {
    // NOTE: removes unwanted whitespace and moves newline break appearing at the beginning
    // of textContent/innerHTML of <p> elements to the end
    const htmlElementWithoutSpaces = htmlElement.textContent === null ? '' : htmlElement.textContent.trim();
    if (htmlElement.textContent !== null && htmlElement.textContent.startsWith('\n')) {
        return `${htmlElementWithoutSpaces}\n`;
    }
    return htmlElementWithoutSpaces;
};
const convertHTMLToTxt = (html) => {
    const tempDivElement = document.createElement('div');
    tempDivElement.innerHTML = html;
    const elms = tempDivElement.querySelectorAll('p, h1, h2, h3, h4');
    return Array.from(elms)
        .map(removeUnwantedSpaces)
        .join('\n');
};
const getExportUrl = (taskId, format) => {
    if (format === 'trsx') {
        return `${siteOrigin}/apps/splitter/API/Export/Trsx?&mediaFileId=${taskId}`;
    }
    return `${siteOrigin}/apps/splitter/API/Export/BeeyExport?&mediaFileId=${taskId}&formatId=${format === 'txt' ? 'html' : format}`;
};
const fetchData = async (connection, url, format) => {
    if (format === 'docx') {
        return connection.authFetch()
            .url(url)
            .blob()
            .fetch();
    }
    const fetchedText = await connection.authFetch()
        .url(url)
        .text()
        .fetch();
    if (format === 'txt') {
        return convertHTMLToTxt(fetchedText);
    }
    return fetchedText;
};
const download = async (projectName, taskId, connection, format) => {
    const url = getExportUrl(taskId, format);
    const [formatExtension] = format.split('_');
    const dataToDownload = fetchData(connection, url, format);
    const downloadUrl = window.URL.createObjectURL(new Blob([await dataToDownload]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', `${projectName.split('.')[0]}.${formatExtension}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
};
export default download;
